import { IonItem, IonNote } from '@ionic/react';
import classNames from 'classnames';
import React from 'react';

import CustomIonSelect from '../../customionselect/CustomIonSelect';

type CustomIonSelectProps = React.ComponentPropsWithoutRef<
    typeof CustomIonSelect
>;
type DefaultSelectProps = CustomIonSelectProps & {
    errorText?: string | React.ReactNode;
    helperText?: string | React.ReactNode;
};
const DefaultSelect: React.FC<DefaultSelectProps> = ({
    children,
    className,
    errorText,
    helperText,
    ...rest
}) => {
    return (
        <div className="default-select">
            <IonItem lines="full" className={classNames('full', className)}>
                <CustomIonSelect labelPlacement="stacked" {...rest}>
                    {children}
                </CustomIonSelect>
            </IonItem>
            {helperText && <IonNote class="helper">{helperText}</IonNote>}
            {errorText && <IonNote class="error">{errorText}</IonNote>}
        </div>
    );
};

export default DefaultSelect;
